// import Vue from 'vue'
// import VueI18n from ''

// Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: "ru",
  fallbackLocale: "gb",
  messages: {
    ru: {
      auth: {
        signIn: "Вход",
        login: "Логин",
        password: "Пароль",
      },
      nav: {
        tubes: "Трубы",
        modems: "Модемы",
        users: "Пользователи",
        addModem: "Добавить модем",
        messages: "Сообщения",
        telList: "Список телефонов",
        signOut: "Выход",
        oneWireData: "Данные OneWire"
      },
      tubes: {
        tube: "Труба",
        modem: "Модем",
        serialNumber: "Серийный номер",
        activity: "Активность",
        isol: "Изоляция",
        battery: "Батарея",
        wire: "Провод",
        phones: "Телефоны",
        coordinates: "Координаты",
        comment: "Комментарий",
        enterComment: "Введите комментарий",
        saveComment: "Сохранить",
        year: "Год",
        halfYear: "Полгода",
        days30: "30 дней",
        days10: "10 дней",
        days2: "2 дня",
        day1: "День",
        isolResistance: "Сопротивление изоляции",
        ohm: "Ом",
        kOhm: "кОм",
        photo: "Фото",
      },
      modems: {
        sN: "С/Н",
        modem: "Модем",
        fullSerial: "Полный серийный",
        tube: "Труба",
        activity: "Активность",
        battery: "Батарея",
        coords: "Координаты",
        comment: "Комментарий",
        enterComment: "Введите комментарий",
        saveComment: "Сохранить",
        aboutDevice: "Об устройстве",
        receivingTime: "Время получения",
        formationTime: "Время формирования",
        allReason: "Вcе типы сообщений",
        messageReason: "Тип сообщения",
        temperature: "Температура",
        temperatureUnit: "°C",
        batteryLevel: "Уровень батареи",
        // IMEI: 'IMEI',
        // ICCID: '',
        // NUM: 'UTC',
        year: "Год",
        halfYear: "Полгода",
        days30: "30 дней",
        days10: "10 дней",
        days2: "2 дня",
        day1: "День",
        onewire: "Onewire Температура",
        onewireP: "Onewire Давление",
        pressure: "Давление",
      },
      users: {
        login: "Логин",
        password: "Пароль",
        email: "E-mail",
        group: "Группа",
        user: "Пользователь",
        admin: "Администратор",
        phone: "Телефон",
        checkbox1: "Извещать о важных событиях",
        checkbox2: "Извещать о всех событиях",
        edit: "Редактировать",
        create: "Создать",
        delete: "Удалить",
        save: "Сохранить",
        cancel: "Отменить",
        enterLogin: "введите логин",
        enterPassword: "введите пароль",
        incorrectEmail: "некорректный e-mail",
        phoneFormat: "формат номера 375XXXXXXXXX",
        unchanged: "не изменен",
        dontMatch: "не совпадает",
      },
      addModem: {
        tube: "Труба",
        modemsSN: "С/Н модема",
        addModemh1: "Добавление нового модема",
        manually: "Ввести вручную",
        fromFile: "Загрузить из файла",
        serialNumber: "Серийный номер модема (номер по порядку)",
        fullSerial: "Полный серийный номер модема (IMEI)",
        tubeName: "Название трубы",
        scanQR: "Сканируйте qr-код или",
        qrLink: "Пройдите по ссылке",
        modemComment: "Комментарий к модему",
        tubeComment: "Комментарий к трубе",
        enterComment: "Введите комметарий",
        modemCoords: "Координаты модема",
        tubeCoords: "Координаты трубы",
        addContacts: "Добавить контакты",
        chooseAll: "Выбрать все",
        resetAll: "Сбросить все",
        addAndContinue: "Добавить и продолжить",
        addModemButton: "Добавить модем",
        ok: "Хорошо",
        addStatus: "Статус добавления элемента",
        message1: "Обязательно для заполнения!",
        message2: "Неверный формат координат",
        message3: "Такой элемент уже есть в списке!",
        message4: "Элемент был успешно добавлен!",
        editTubeData: "Отредактируйте данные о трубе",
        editContacts: "Изменить контакты",
        serNumber: "Серийный номер",
        fullSerNumber: "Полный серийный номер"
      },
      messages: {
        sN: "С/Н",
        time: "Время",
        modemSN: "С/Н модема",
        tube: "Труба",
        message: "Сообщение",
        filterBy: "Фильтровать по",
        break: "Обрыв",
        lowBattery: "Разряжена батарея",
        sodden: "Намокание",
        noSignal: "Нет сигнала",
        resetButton: "Сбросить",
        break2: " Обрыв провода \n",
        sodden2: " Намокание трубы \n",
        lowBattery2: " Батарея разряжена \n",
        noSignal2: " Долго нет сигнала \n",
      },
      phoneList: {
        employee: "Сотрудник",
        phone: "Телефон",
        addEmployee: "Добавить сотрудника",
        editDetails: "Отредактируйте данные сотрудника:",
        defaultContact: "Контакт по умолчанию",
        edit: "Изменить",
        cancel: "Отмена",
        add: "Добавить",
        addNewEmployee: "Добавить нового сотрудника:",
        employeeName: "ФИО сотрудника",
        phoneNumber: "Номер телефона",
        position: "Должность",
        email: "Email",
      },
      general: {
        search: "Поиск",
        lang: "Русский",
        langType: "ru",
        edit: "Изменить",
        cancel: "Отмена",
      },
    },
    gb: {
      auth: {
        signIn: "Sign in",
        login: "Login",
        password: "Password",
      },
      nav: {
        tubes: "Tubes",
        modems: "Modems",
        users: "Users",
        addModem: "Add modem",
        messages: "Messages",
        telList: "Phone list",
        signOut: "Sign out",
        oneWireData: "OneWire Data"
      },
      tubes: {
        tube: "Tube",
        modem: "Modem",
        serialNumber: "Serial number",
        activity: "Activity",
        isol: "Insulation",
        battery: "Battery",
        wire: "Wire",
        phones: "Phones",
        coordinates: "Coordinates",
        comment: "Comment",
        enterComment: "Enter comment",
        saveComment: "Save",
        year: "Year",
        halfYear: "Half a year",
        days30: "30 days",
        days10: "10 days",
        days2: "2 days",
        day1: "1 day",
        isolResistance: "Insulation resistance",
        ohm: "Ohm",
        kOhm: "kOhm",
        photo: "Photo",
      },
      modems: {
        sN: "S/N",
        modem: "Modem",
        fullSerial: "Full serial",
        tube: "Tube",
        activity: "Activity",
        battery: "Battery",
        coords: "Coordinates",
        comment: "Comment",
        enterComment: "Enter comment",
        saveComment: "Save",
        aboutDevice: "About device",
        receivingTime: "Receiving time",
        formationTime: "Formation time",
        allReason: "All message's reasons",
        messageReason: "Message's reason",
        temperature: "Temperature",
        temperatureUnit: "°C",
        batteryLevel: "Battery level",
        // IMEI: 'IMEI',
        // ICCID: '',
        // NUM: 'UTC',
        year: "Year",
        halfYear: "Half a year",
        days30: "30 days",
        days10: "10 days",
        days2: "2 days",
        day1: "1 day",
        onewire: "Onewire Temperature",
        onewireP: "Onewire Pressure",
        pressure: "Pressure",
      },
      users: {
        login: "Login",
        password: "Password",
        email: "E-mail",
        group: "Group",
        user: "User",
        admin: "Admin",
        phone: "Phone",
        checkbox1: "Notify about important events",
        checkbox2: "Notify about all events",
        edit: "Edit",
        create: "Create",
        delete: "Delete",
        save: "Save",
        cancel: "Cancel",
        enterLogin: "enter login",
        enterPassword: "enter password",
        incorrectEmail: "incorrect e-mail",
        phoneFormat: "number format 375XXXXXXXXX",
        unchanged: "unchanged",
        dontMatch: "doesn't match",
      },
      addModem: {
        tube: "Tube",
        modemsSN: "Modem S/N",
        addModemh1: "Adding a new modem ",
        manually: "Enter manually",
        fromFile: "Load from file",
        serialNumber: "Modem serial number",
        fullSerial: "Modem full serial number",
        tubeName: "Tube name",
        scanQR: "Scan QR code or",
        qrLink: "Follow the link",
        modemComment: "Modem comment",
        tubeComment: "Tube comment",
        enterComment: "Enter comment",
        modemCoords: "Modem coordinates",
        tubeCoords: "Tube coordinates",
        addContacts: "Add contacts",
        chooseAll: "Choose all",
        resetAll: "Reset all",
        addAndContinue: "Add and continue",
        addModemButton: "Add modem",
        ok: "Ok",
        addStatus: "Item adding status",
        message1: "Required to fill out!",
        message2: "Invalid coordinate format",
        message3: "This item is already in the list!",
        message4: "The item was added successfully!",
        editTubeData: "Edit tube data",
        editContacts: "Edit contacts",
        serNumber: "Serial number",
        fullSerNumber: "Full serial number",
      },
      messages: {
        sN: "S/N",
        time: "Time",
        modemSN: "Modem S/N",
        tube: "Tube",
        message: "Message",
        filterBy: "Filter by",
        break: "Break",
        lowBattery: "Low battery",
        sodden: "Sodden",
        noSignal: "No signal",
        resetButton: "Reset",
        break2: " Broken wire \n",
        sodden2: " Sodden tube \n",
        lowBattery2: " Battery discharged \n",
        noSignal2: " Long no signal \n",
      },
      phoneList: {
        employee: "Employee",
        phone: "Phone",
        addEmployee: "Add employee",
        editDetails: "Edit employee details:",
        defaultContact: "Default contact",
        edit: "Edit",
        cancel: "Cancel",
        add: "Add",
        addNewEmployee: "Add new employee:",
        employeeName: "Name of employee",
        phoneNumber: "Phone number",
        position: "Position",
        email: "Email",
      },
      general: {
        search: "Search",
        lang: "English",
        langType: "gb",
        edit: "Edit",
        cancel: "Cancel",
      },
    },
  },
});



// WEBPACK FOOTER //
// ./src/app/js/plugins/i18n.js